<script setup lang="ts">
import {ref} from "vue";
import {Scale} from "@lucide/vue";
import DeontologyDialog from "@/birthday-gift/components/DeontologyDialog.vue";

const dialogOpen = ref(false);
</script>

<template>
  <div class="flex items-start gap-3 rounded-lg border border-orange bg-white px-4 py-3">
    <Scale class="mt-0.5 h-5 w-5 shrink-0" />
    <div class="text-sm leading-relaxed">
      Pensez à respecter le
      <button
        type="button"
        class="font-semibold text-primary underline"
        @click="dialogOpen = true"
      >
        code de déontologie
      </button>
      : un cadeau d'anniversaire est possible, mais sous conditions.
    </div>
  </div>
  <DeontologyDialog v-model:open="dialogOpen" />
</template>
